module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki13_sp-f533c61cf83cefcb0086fdfa6be8e945.jpg";